import { activity } from '@ax/service';
import { useMutation } from '@tanstack/react-query';

export function useActivity() {
  const activityMutation = useMutation({
    mutationKey: ['activity'],
    mutationFn: () => activity(),
    onError: (error: any) => {
      console.log(error);
    },
  });
  return activityMutation;
}
